export const REQUIREMENT_IRRELEVANT = 1;
export const REQUIREMENT_9_CLASS = 2;
export const REQUIREMENT_11_CLASS = 3;